import * as React from 'react';
import { DayData } from 'booking/lib/types';
import classnames from 'classnames';
import { useABTesting } from 'core/components/ABTestingProvider/ABTestingProvider';
import * as styles from './DateForm.module.scss';

function checkDayAvailability(
    day: DayData,
    pageVariation?: string | null,
): boolean {
    if (pageVariation === 'availabilityTest1') {
        // We show the availability of today even if there are no spaces
        if (day.isToday) {
            return true;
        }

        // If it's full but not today, disable it
        if (!day.hasSlots) {
            return false;
        }
    }

    // Disable dates before opening
    if (day.isBeforeOpening) {
        return false;
    }

    // Disable dates in the past
    if (day.isPast) {
        return false;
    }

    // Defaults to true
    return true;
}

export type WeekProps = {
    day: DayData | null;
    onSelect: (date: string) => void;
    classes?: Partial<typeof styles>;
    isWellnessWednesday?: boolean;
};

function Day({
    day,
    onSelect,
    classes,
    isWellnessWednesday,
    children,
}: React.PropsWithChildren<WeekProps>) {
    const { getPageVariation } = useABTesting();

    // Retrieve the current page variation
    const pageVariation = getPageVariation();

    if (day) {
        const { date, label, isSelected, isToday } = day;
        if (checkDayAvailability(day, pageVariation)) {
            return (
                <button
                    type="button"
                    className={classnames({
                        [classnames(classes?.isSelected, styles.isSelected)]:
                            isSelected,
                        [classnames(classes?.isToday, styles.isToday)]: isToday,
                        [styles.isSelected]: isSelected,
                        [styles.isToday]: isToday && !isWellnessWednesday,
                    })}
                    onClick={() => onSelect(date)}
                >
                    {label}
                    {children}
                </button>
            );
        }

        return (
            <span className={styles.isPast}>
                {label}
                {children}
            </span>
        );
    }

    return <small />;
}

export default Day;
